import { useEffect } from "react";
import ReactDOM from "react-dom";

function Popup({ isOpen, children, onClose }) {
  useEffect(() => {
    const handleScroll = () => {
      if (isOpen) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "unset";
      }
    };

    handleScroll();

    return () => (document.body.style.overflow = "unset");
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      const popupContainer = document.getElementById("popupContainer");
      if (popupContainer) {
        const childElement = popupContainer.firstElementChild;
        if (childElement) {
          childElement.style.margin = "auto";
        }
      }
    }
  }, [isOpen]);

  const handleClose = (e) => {
    if (e.target.id === "popupContainer") {
      onClose();
    }
  };

  return isOpen
    ? ReactDOM.createPortal(
        <div
          id="popupContainer"
          onClick={handleClose}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "#1F363C80",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
            zIndex: 1000,
            overflowY: "auto",
            padding: "12px",
          }}
        >
          {children}
        </div>,
        document.body
      )
    : null;
}

export default Popup;
